import {Component, OnInit} from '@angular/core';
import {NgForm,FormControl} from '@angular/forms';
import {debounceTime, tap, map } from 'rxjs/operators';
import {Sort} from '@angular/material/sort';
import {GlobalService} from "../../shared/services/global.service";
import {Constantes} from "../../shared/constantes";
import {NotificationService} from "../../shared/services/notification.service";
import {ActivatedRoute} from "@angular/router";
@Component({
  selector: 'app-parameter-value-list',
  templateUrl: './parameter-value-list.component.html',
  styleUrls: ['./parameter-value-list.component.css']
})
export class ParameterValueListComponent implements OnInit {
  parameterCode:string='';
  parameterName:string='';
  parameterId:number= 0;
  nbParameterValues = 0;
  firstPage = 0;
  nextPage = 0;
  lastPage = 0;
  page: number = 1;
  parameterValueLists: any = [];
  parameterValue: any = [];
  parametersValuesNameLists: any = [];
  searchParameterName = new FormControl();
  filteredParameterValues: any;
  isLoading = false;
  errorMsg: string = '';
  value = 'resolve';
  allowClear = true;
  required = true;
  disabled = false;
  currentPage = 1;
  maxItem = Constantes.maxItemsPerPage;
  UserRole=localStorage.getItem('User_roles');
  ElementId:number =0;
  constructor(
    private globalService: GlobalService,
    private notification: NotificationService,
    private activatedRouter:ActivatedRoute) {
  }

  ngOnInit(): void {
    this.parameterCode = this.activatedRouter.snapshot.params['parameterCode'];
    this.parameterName=this.activatedRouter.snapshot.params['parameterName'];
    this.getAllParameterValues();
    this.GetParameterValueName();
  }

  getAllParameterValues() {
    this.globalService.showSpinner();
    this.parameterValueLists = [];
    this.globalService.getParameterValue('', this.parameterCode,null,null,null).subscribe(
      parameterValueLists => {
        this.parameterValueLists = parameterValueLists[0]['data'];
        if(this.parameterValueLists.length>0)
        {
          this.parameterName=this.parameterValueLists['0']['parameter']['name'];
          this.parameterId=this.parameterValueLists['0']['parameter']['id'];
        }
        this.nbParameterValues = 0;
        this.lastPage = 0;
        this.nbParameterValues = parameterValueLists[0]['info'][0]['totalItems'];
        this.lastPage = Math.ceil(this.nbParameterValues / this.maxItem);
        this.globalService.hideSpinner();
        console.log('this.parameterValueLists',this.parameterValueLists);
      },
      error => {
        this.globalService.checkApiError(error);
        this.globalService.hideSpinner();
      }
    )
  }

  displayFn: any;

  GetParameterValueName() {
    this.searchParameterName.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredParameterValues = [];
          this.isLoading = true;
        }),
        map((paramName: string) => paramName.toString().trim())
      )
      .subscribe((paramName: string) => {
          this.globalService.getParameterValue('', this.parameterCode,null,null,null, paramName).subscribe(
            searchResponse => {
              if (searchResponse[0] !== undefined) {
                this.isLoading = false;
                this.parametersValuesNameLists = searchResponse[0]['data'];
              }
            },
            error => {
              this.globalService.checkApiError(error);
            }
          )

        }
      );

  }

  searchParameterValues(form: NgForm, page = 1) {
    this.globalService.showSpinner();
    let name = this.searchParameterName.value;
    let etat = form.value.etat;
    let code = form.value.code;
    this.parameterValueLists = [];
    this.globalService.getParameterValue('', this.parameterCode,etat,code,null, name,page,true).subscribe(
      (searchResponse: any) => {
        this.parameterValueLists = searchResponse[0]['data'];
        this.lastPage = 0;
        this.nbParameterValues = 0;
        this.nbParameterValues = searchResponse[0]['info'][0]['totalItems'];
        this.lastPage = Math.ceil(this.nbParameterValues / Constantes.maxItemsPerPage);
        this.globalService.hideSpinner();
        console.log('****   parameterValueLists   =============== >' ,this.parameterValueLists);
      },
      (error: any) => {
        this.globalService.checkApiError(error);
        this.globalService.hideSpinner();
      }
    )

  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort) {
    const data = this.parameterValueLists.slice();
    if (!sort.active || sort.direction === '') {
      this.parameterValueLists = data;
      return;
    }

    this.parameterValueLists = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return this.compare(a.id, b.id, isAsc);
        case 'code':
          return this.compare(a.code, b.code, isAsc);
        case 'nameFr':
          return this.compare(a.name, b.name, isAsc);
        case 'createdAt':
          return this.compare(a.createdAt, b.createdAt, isAsc);
        case 'updatedAt':
          return this.compare(a.updatedAt, b.updatedAt, isAsc);
        case 'active':
          return this.compare(a.isActive, b.isActive, isAsc);
        case 'master':
          return this.compare(a.isMaster, b.isMaster, isAsc);
        default:
          return 0;
      }
    });
  }

  pagesCounter(i: number) {
    return new Array(i);
  }

  loadNextPage(form: NgForm, pageNumber: number) {
    this.currentPage = pageNumber;
    if (pageNumber <= this.lastPage && pageNumber > 0) {
      this.searchParameterValues(form, pageNumber);
    }
  }

  editParameterValues(parameterValue: any)
  {
    this.parameterValue = parameterValue;
  }

  deleteParameterValues(item: any) {
    let globalService = this.globalService;
    let parameterValueLists = this.parameterValueLists;
    let notification = this.notification;
    this.notification.ConfirmAction("Êtes-vous sûr de vouloir supprimer", item.nameFr, "Valider", "Supprimer !", "", function (confirmed: any) {
      if (confirmed) {
        globalService.deleteParameterValues(item.id).subscribe(
          deletedResponse => {
            let index = parameterValueLists.indexOf(item);
            if (index > -1) {
              parameterValueLists.splice(index, 1);
              notification.showSuccess("La valeur ' " + item.nameFr + " ' a été supprimée avec succès", "");
              $("html, body").animate({scrollTop: 0}, "slow");
            }
          },
          error => {
            globalService.checkApiError(error);
            notification.showError(error['error']['hydra:description'], "");
          }
        );
      } else {
        console.log('response ==> false');
      }
    });
  }

  ShowLogs(ElementId: number)
  {
    this.ElementId = ElementId;
  }
}

